import { darkTheme, styled } from "../style/stitches.config";

export const ToggleSlider = ({
  isOn,
  setIsOn,
}: {
  isOn: boolean;
  setIsOn: Function;
}) => {
  return (
    <StyledToggleSlider isOn={isOn} onClick={() => setIsOn(!isOn)}>
      <div className="toggle-button"></div>
    </StyledToggleSlider>
  );
};

const StyledToggleSlider = styled("div", {
  width: "32px",
  backgroundColor: "$gray200",
  [`.${darkTheme.className} &`]: { backgroundColor: "rgba(255, 255, 255, 0.25)" },
  borderRadius: "8px",
  height: "16px",
  display: "flex",
  cursor: "pointer",
  alignItems: "center",
  position: "relative",
  transition: "all 0.2s",

  "& .toggle-button": {
    width: "14px",
    height: "14px",
    backgroundColor: "white",
    borderRadius: "50%",
    left: "1px",
    position: "absolute",
    transition: "all 0.2s",
  },
  variants: {
    isOn: {
      true: {
        backgroundColor: "black",
        [`.${darkTheme.className} &`]: {
          backgroundColor: "#fff",
          "& .toggle-button": { backgroundColor: "#000" },
        },
        "& .toggle-button": {
          left: "17px",
        },
      },
    },
  },
});
